import { Component, inject, Input, OnInit } from '@angular/core';
import { ezAnimations } from 'src/shared/animations';
import { globalWindow } from 'src/shared/window-globals';
import { WorkspaceService } from '../../workspace.service';

@Component({
  selector: 'ez-task-group',
  templateUrl: './task-group.component.html',
  styleUrls: ['./task-group.component.scss'],
  animations: [ezAnimations.iconSwap],
  standalone: false,
})
export class TaskGroupComponent implements OnInit {
  @Input() tasks: any;
  @Input() groupTitle: string;
  @Input() showImportantOnly: boolean;
  @Input() taskContext: any;
  @Input() showTasks: boolean;

  taskDescriptionLimit = 150;
  taskPriorityDueTimeEnabled: boolean;

  readonly #workspaceService = inject(WorkspaceService);

  ngOnInit(): void {
    // read workspace permissions
    this.#workspaceService.getWorkspacePermissions()
      .then((permissions) => {
        this.taskPriorityDueTimeEnabled = permissions.taskPriorityDueTimeEnabled;
      });
  }

  taskCounts(tasks: any): string {
    let countDesc = '';
    if (!this.showImportantOnly) {
      countDesc += tasks.length.toString();
      if (tasks.importantLength && this.taskPriorityDueTimeEnabled) {
        countDesc += ', ';
      }
    }
    if (tasks.importantLength && this.taskPriorityDueTimeEnabled) {
      countDesc += tasks.importantLength.toString();
    }

    return countDesc;
  }

  showTaskDetails(task: any): void {
    this.#workspaceService.workspaceState.selectTask.emit(task.taskId);
  }

  toggleTaskDescription(task: any): void {
    if (task.taskDescription.length > task.taskCharLimit) {
      task.taskCharLimit = task.taskDescription.length;
    } else {
      task.taskCharLimit = this.taskDescriptionLimit;
    }
  }

  goToAccount(applicantId: number): void {
    if (globalWindow.fiveComponentRef) {
      (globalWindow.fiveComponentRef as any).routerLink(`/account/${applicantId}/overview`);
    } else {
      window.location.href = `/web/account/${applicantId}/overview`;
    }
  }
}
